/**
 * @fileoverview DELETE handler for the "/generative_ai/brand_guideline_document" endpoint
 */
import fetch from "@lib/fetch";

import {
  createMutationFetcherFunctionWithShadowError,
  reactQueryMutationAdapter,
} from "../reactQueryFetcherAdapters";
import { deleteGenerativeAiBrandGuidelineDocumentCacheKeys } from "./constants";
import type {
  BrandGuidelineDocumentRequestError,
  DeleteGenerativeAiBrandGuidelineDocumentProps,
  DeleteGenerativeAiBrandGuidelineDocumentResult,
} from "./types";

export const deleteGenerativeAiBrandGuidelineDocument = reactQueryMutationAdapter(
  deleteGenerativeAiBrandGuidelineDocumentCacheKeys,
  createMutationFetcherFunctionWithShadowError<BrandGuidelineDocumentRequestError>()(
    ({
      guidelineId,
      documentId,
    }: DeleteGenerativeAiBrandGuidelineDocumentProps): Promise<DeleteGenerativeAiBrandGuidelineDocumentResult> => {
      return fetch(
        "/generative_ai/brand_guideline_document",
        "DELETE",
        { guideline_id: guidelineId, document_id: documentId },
        undefined,
        { propagateFetchRequestError: false }
      );
    }
  )
);
